import { getOrderTickets } from './get-order-tickets';
export const getOrderTicketQuantityForRedemptionCard = (ticketRedemptionCardId) => {
    return getOrderTickets().filter(ticket => ticket.ticketRedemptionCardId === ticketRedemptionCardId).length;
};
